$(document).ready(function() {

    $('body').on('click', '.mini_cart_item .remove', function(e) {
      e.preventDefault();

      var $thisbutton = $( this );
      var data = {
        item_key: $thisbutton.data('item_key')
      };

      $thisbutton.closest('.popover').addClass('loading');

      // Ajax action
      $.post( '/remove-item-from-cart', data, function( response ) {
        if ( ! response ) {
          return;
        }

        if (response.message) {
          alert(response.message);
          return;
        }

        var fragments = response.fragments;

        $.ajax({
          url: "/get-cart-count/",
          method: "GET",
          success: function(resp) {
            // Update cart count
            if ( resp > 99) {
              resp = '99+';
            }
            $(".cart-count").html(resp);

            $thisbutton.closest('.popover').removeClass('loading');

            // Replace fragments
            if (fragments) {
              $.each( fragments, function( key, value ) {
                $( key ).replaceWith( value );
              });
            }
          }
        });
      });

    });

});
